export function applicationVersionNumberSelect(state) {
  return state ? state.applicationVersion.applicationVersionNumber : 0;
}
